// Mock data for Apex Stream

export const heroData = {
  title: "Apex Stream",
  subtitle: "Assista aos melhores jogos, filmes e séries em um só lugar",
  ctaText: "Assista Agora!",
  backgroundImage: "https://images.pexels.com/photos/31543214/pexels-photo-31543214.jpeg"
};

export const categories = [
  {
    id: 1,
    name: "Esportes",
    description: "Futebol ao vivo, highlights e muito mais",
    image: "https://images.pexels.com/photos/2570139/pexels-photo-2570139.jpeg",
    icon: "Trophy"
  },
  {
    id: 2,
    name: "Filmes",
    description: "Os melhores filmes em HD",
    image: "https://images.pexels.com/photos/33129/popcorn-movie-party-entertainment.jpg",
    icon: "Film"
  },
  {
    id: 3,
    name: "Séries",
    description: "Maratone suas séries favoritas",
    image: "https://images.pexels.com/photos/1763075/pexels-photo-1763075.jpeg",
    icon: "Tv"
  }
];

export const benefits = [
  {
    id: 1,
    icon: "MonitorPlay",
    title: "Multi-Dispositivos",
    description: "Assista em qualquer dispositivo - TV, celular, tablet ou computador"
  },
  {
    id: 2,
    icon: "Sparkles",
    title: "Qualidade HD/4K",
    description: "Transmissão em alta definição para a melhor experiência"
  },
  {
    id: 3,
    icon: "Zap",
    title: "Transmissão Ao Vivo",
    description: "Acompanhe jogos e eventos ao vivo sem atrasos"
  },
  {
    id: 4,
    icon: "Clock",
    title: "Disponível 24/7",
    description: "Conteúdo disponível quando você quiser, onde você estiver"
  }
];

export const featuredContent = [
  {
    id: 1,
    title: "Brasileirão 2024",
    category: "Esportes",
    image: "https://images.pexels.com/photos/1171084/pexels-photo-1171084.jpeg",
    type: "live"
  },
  {
    id: 2,
    title: "Cinema em Casa",
    category: "Filmes",
    image: "https://images.pexels.com/photos/436413/pexels-photo-436413.jpeg",
    type: "movie"
  },
  {
    id: 3,
    title: "Shows e Eventos",
    category: "Entretenimento",
    image: "https://images.pexels.com/photos/1190297/pexels-photo-1190297.jpeg",
    type: "event"
  },
  {
    id: 4,
    title: "Champions League",
    category: "Esportes",
    image: "https://images.unsplash.com/photo-1522778119026-d647f0596c20",
    type: "live"
  },
  {
    id: 5,
    title: "Blockbusters",
    category: "Filmes",
    image: "https://images.pexels.com/photos/33129/popcorn-movie-party-entertainment.jpg",
    type: "movie"
  },
  {
    id: 6,
    title: "Séries Originais",
    category: "Séries",
    image: "https://images.pexels.com/photos/1763075/pexels-photo-1763075.jpeg",
    type: "series"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Carlos Silva",
    comment: "Melhor plataforma de streaming que já usei! Qualidade impecável e sempre tem os jogos que quero assistir.",
    rating: 5
  },
  {
    id: 2,
    name: "Maria Santos",
    comment: "Adoro poder assistir meus filmes favoritos em qualquer lugar. A interface é muito fácil de usar!",
    rating: 5
  },
  {
    id: 3,
    name: "João Oliveira",
    comment: "Transmissões ao vivo sem travamentos. Perfeito para acompanhar todos os campeonatos!",
    rating: 5
  }
];

export const footerLinks = {
  company: [
    { name: "Sobre Nós", href: "#sobre" },
    { name: "Carreiras", href: "#carreiras" },
    { name: "Imprensa", href: "#imprensa" }
  ],
  support: [
    { name: "Central de Ajuda", href: "#ajuda" },
    { name: "Contato", href: "#contato" },
    { name: "FAQ", href: "#faq" }
  ],
  legal: [
    { name: "Termos de Uso", href: "#termos" },
    { name: "Privacidade", href: "#privacidade" },
    { name: "Cookies", href: "#cookies" }
  ],
  social: [
    { name: "Facebook", icon: "Facebook", href: "#" },
    { name: "Instagram", icon: "Instagram", href: "#" },
    { name: "Twitter", icon: "Twitter", href: "#" },
    { name: "YouTube", icon: "Youtube", href: "#" }
  ]
};
